// Reserved provider-neutral contract. An ingestion adapter must supply a named
// provider and fixture-level home/away xGoals; never substitute model xG.
export function externalXGoalsGames(
  games,
  provider = null,
  venue = "all",
  teamId = null
) {
  const eligible = games.filter(
    (g) => venue === "all" || g[venue + "_team_id"] === Number(teamId)
  );
  const providers = [
    ...new Set(
      eligible
        .filter((g) => g.external_xgoals?.kind !== "should_goals_substitute")
        .map((g) => g.external_xgoals?.provider)
        .filter((p) => typeof p === "string" && p.trim())
    ),
  ];
  const selected = provider || (providers.length === 1 ? providers[0] : null);
  const covered = eligible
    .filter((g) => {
      const x = g.external_xgoals;
      return (
        ((selected && x?.provider === selected) || x?.kind === "should_goals_substitute") &&
        [x.home, x.away].every(
          (v) => typeof v === "number" && Number.isFinite(v) && v >= 0
        )
      );
    })
    .map((g) => ({
      ...g,
      should: { home: g.external_xgoals.home, away: g.external_xgoals.away },
    }));
  return {
    provider: selected || (covered.length ? "should_goals" : null),
    providers,
    games: covered,
    total: eligible.length,
  };
}
